module.exports = __webpack_public_path__ + "img/7.b4463fa6.png";